import React, { useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { Button, CircularProgress, Alert } from '@mui/material';
import { formatReadableAmount } from "../../Common/FormatFunctions/FormatAmount"
import Swal from 'sweetalert2';
const API_URL = process.env.REACT_APP_API;

const SaleTDSSummary = ({ fromDate, toDate, companyCode, yearCode, Tran_type, accode }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isDataFetched, setIsDataFetched] = useState(false);

    const fetchSaleTDSSummary = async () => {
        try {
            setLoading(true);
            setError('');
            const response = await axios.get(`${API_URL}/SaleTDS-summary`, {
                params: {
                    from_date: fromDate,
                    to_date: toDate,
                    Company_Code: companyCode,
                    Year_Code: yearCode,
                    Tran_type: Tran_type,
                    accode: accode
                },
            });
            if (response.data.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Data Not Found.!',
                    text: 'No Sale TDS data found for the selected date range.',
                });
                return;
            }
            setData(response.data);
            setIsDataFetched(true);
            openInNewWindow(response.data);
        } catch (err) {
            setError('Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };

    const openInNewWindow = (data) => {
        const newWindow = window.open('', '_blank');
        if (!newWindow) return;

        const exportToXlsxScript = `
        function exportToXlsx() {
            const data = ${JSON.stringify(data)};
            const columnOrder = [
                "SR_No", "InvoiceNo", "date", "Name Of Party", "Pan", "Tan", "Address", 
                "Taxable_Amt", "CGST", "SGST", "IGST", "Bill_Amt", "TDS"
            ];
            
            const formattedData = data.map(row => {
                return {
                    ...row,
                    Taxable_Amt: parseFloat(row.Taxable_Amt) || 0,
                    CGST: parseFloat(row.CGST) || 0,
                    SGST: parseFloat(row.SGST) || 0,
                    IGST: parseFloat(row.IGST) || 0,
                    Bill_Amt: parseFloat(row.Bill_Amt) || 0,
                    TDS: parseFloat(row.TDS) || 0,
                };
            });

            const ws = XLSX.utils.json_to_sheet(formattedData, { header: columnOrder, skipHeader: false });

            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let row = range.s.r + 1; row <= range.e.r; row++) {
                const taxableAmtCell = ws[XLSX.utils.encode_cell({ r: row, c: 7 })]; 
                const cgstCell = ws[XLSX.utils.encode_cell({ r: row, c: 8 })]; 
                const sgstCell = ws[XLSX.utils.encode_cell({ r: row, c: 9 })];
                const igstCell = ws[XLSX.utils.encode_cell({ r: row, c: 10 })]; 
                const billAmtCell = ws[XLSX.utils.encode_cell({ r: row, c: 11 })]; 
                const tdsCell = ws[XLSX.utils.encode_cell({ r: row, c: 12 })];
                
                // Set number format for each of the numeric columns
                if (taxableAmtCell) taxableAmtCell.z = '0.00';
                if (cgstCell) cgstCell.z = '0.00';
                if (sgstCell) sgstCell.z = '0.00';
                if (igstCell) igstCell.z = '0.00';
                if (billAmtCell) billAmtCell.z = '0.00';
                if (tdsCell) tdsCell.z = '0.00';
            }

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "SaleTDSData");
            const xlsx = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([xlsx], { type: "application/octet-stream" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "SaleTDSSummary.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    `;


        newWindow.document.write(`
            <html>
                <head>
                    <title>Sale TDS Summary</title>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>
                    <script>${exportToXlsxScript}</script>
                                <style>
                body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
                h2 { text-align: center; margin-top: 0; }
                .table-container {
                    max-height: 500px;
                    overflow-y: auto;
                    margin: 20px auto;
                    width: 90%;
                }
                table {
                    width: 100%;
                    border-collapse: collapse;
                }
                th, td {
                    border: 1px solid #ddd;
                    padding: 6px 8px;
                    text-align: left;
                    white-space: nowrap;
                }
                th {
                    background-color:rgb(206, 200, 243);
                    position: sticky;
                    top: 0;
                    z-index: 2;
                    font-weight: bold;
                    font-size: 20px;
                    height: 50px;
                    text-align: center;
                }
                .export-btn {
                    padding: 10px 20px;
                    font-size: 16px;
                    background-color: green;
                    color: white;
                    border: none;
                    cursor: pointer;
                    margin-bottom: 20px;
                    margin-top: 20px;
                }
                .total-row {
                    background-color: yellow;
                    font-weight: bold;
                }
            </style>
                </head>
                <body>
                    <h2>Sale TDS Summary Report</h2>
                    <button class="export-btn" onclick="exportToXlsx()">Export to XLSX</button>
                    <table>
                        <thead>
                            <tr>
                                <th style="text-align: center;">SR_No</th>
                                <th style="text-align: center;">InvoiceNo</th>
                                <th style="text-align: center;">Date</th>
                                <th style="text-align: center;">Name Of Party</th>
                                <th style="text-align: center;">Pan</th>
                                <th style="text-align: center;">Tan</th>
                                <th style="text-align: center;">Address</th>
                                <th style="text-align: center;">Taxable Amt</th>
                                <th style="text-align: center;">CGST</th>
                                <th style="text-align: center;">SGST</th>
                                <th style="text-align: center;">IGST</th>
                                <th style="text-align: center;">Bill Amt</th>
                                <th style="text-align: center;">TDS</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${data.map(row => `
                                <tr>
                                    <td>${row.SR_No || ''}</td>
                                    <td>${row.InvoiceNo || ''}</td>
                                    <td>${row.date || ''}</td>
                                    <td>${row["Name Of Party"] || ''}</td>
                                    <td>${row.Pan || ''}</td>
                                    <td>${row.Tan || ''}</td>
                                    <td>${row.Address || ''}</td>
                                    <td style="text-align: right;">${formatReadableAmount(row.Taxable_Amt || '')}</td>
                                    <td style="text-align: right;">${formatReadableAmount(row.CGST || '')}</td>
                                    <td style="text-align: right;">${formatReadableAmount(row.SGST || '')}</td>
                                    <td style="text-align: right;">${formatReadableAmount(row.IGST || '')}</td>
                                    <td style="text-align: right;">${formatReadableAmount(row.Bill_Amt || '')}</td>
                                    <td style="text-align: right;">${formatReadableAmount(row.TDS || '')}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </body>
            </html>
        `);

        newWindow.document.close();
    };

    return (
        <div style={{ textAlign: 'center', marginTop: '5px' }}>
            <Button
                variant="contained"
                color="primary"
                onClick={fetchSaleTDSSummary}
                disabled={loading}
                style={{
                    width: '15%',
                    height: '60px',
                }}
            >
                {loading ? <CircularProgress size={24} /> : 'Sale TDS Summary'}
            </Button>
            {error && <Alert severity="error">{error}</Alert>}
        </div>
    );
};

export default SaleTDSSummary;
